var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 9.16667H15.4167C15.7482 9.16667 16.0661 9.03497 16.3006 8.80055C16.535 8.56613 16.6667 8.24819 16.6667 7.91667C16.6667 7.58515 16.535 7.2672 16.3006 7.03278C16.0661 6.79836 15.7482 6.66667 15.4167 6.66667H14.1667V10.8333M14.1667 14.1667V17.5H15C15.442 17.5 15.866 17.3244 16.1785 17.0118C16.4911 16.6993 16.6667 16.2754 16.6667 15.8333C16.6667 15.3913 16.4911 14.9674 16.1785 14.6548C15.866 14.3423 15.442 14.1667 15 14.1667H14.1667ZM2.5 4.16667C2.5 4.60869 2.67559 5.03262 2.98816 5.34518C3.30072 5.65774 3.72464 5.83333 4.16667 5.83333C4.60869 5.83333 5.03262 5.65774 5.34518 5.34518C5.65774 5.03262 5.83333 4.60869 5.83333 4.16667C5.83333 3.72464 5.65774 3.30072 5.34518 2.98816C5.03262 2.67559 4.60869 2.5 4.16667 2.5C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 5.83333V8.33333C4.16675 8.55434 4.25455 8.7663 4.41083 8.92258C4.56711 9.07886 4.77907 9.16666 5.00008 9.16666H7.50008M7.50008 9.16666V15C7.50008 15.221 7.58788 15.433 7.74416 15.5893C7.90044 15.7455 8.1124 15.8333 8.33341 15.8333H10.8334M7.50008 9.16666H10.8334",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.5cd5c81d097f9925d9624602bce1cee2.svg";
export { ForwardRef as ReactComponent };